import { useCallback } from 'react';
import { AskRequest } from '@hone-automation/common';
import { useCreateGroupMutation } from './useGroupOperationsMutation';

export const useCreateGroup = (locationId: string) => {
  const createGroupMutation = useCreateGroupMutation(locationId);

  const createGroup = useCallback(
    async ({ title, comment, childRequestIds }: { title: string; comment?: string; childRequestIds?: string[] }) => {
      if (!locationId) return;
      const result = await createGroupMutation.mutateAsync({
        locationId,
        title,
        comment,
        ...(childRequestIds && childRequestIds.length > 0 ? { childRequestIds } : {}),
      });
      return result as AskRequest;
    },
    [createGroupMutation, locationId]
  );

  return { createGroup };
};
